module.exports = __webpack_public_path__ + "static/media/spiritairlines.dd081238.png";